// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Book } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconBook(props: any) {
    return <IconBase icon={Book} {...props} />
  }

  export default IconBook
  